// extracted by mini-css-extract-plugin
export var attachmentListWrapper = "message-module--attachment-list-wrapper--598b0";
export var authorLabel = "message-module--author-label--b91f8";
export var avatarHolder = "message-module--avatar-holder--b8bba";
export var contentText = "message-module--content-text--77126";
export var himIsAnOwnerWrapper = "message-module--him-is-an-owner-wrapper--ceeb2";
export var imOwnerWrapper = "message-module--im-owner-wrapper--9df5e";
export var messageWrapper = "message-module--message-wrapper--aec8c";
export var wrapper = "message-module--wrapper--b2197";